import React from 'react';
import { Box, Container, Typography } from '@material-ui/core';
import cx from 'classnames';

import LockIcon from '../../assets/icons/LockIcon';
import { CustomButton } from '../UI/CustomButton';
import { translate } from '../../utils/helpers';
import useStyles from './styles';

interface JoinNowProps {
  isLoggedIn: boolean;
  classes?: {
    container?: string;
    wrapper?: string;
  };
}

const JoinNowBlock: React.FC<JoinNowProps> = ({ isLoggedIn, classes }) => {
  const defaultClasses = useStyles();

  return (
    <Container className={classes?.wrapper ? classes.wrapper : ''}>
      <Box className={cx(defaultClasses.container, classes?.container && classes.container)}>
        <LockIcon className={defaultClasses.lockIcon} />
        <Typography variant="h2" className={defaultClasses.lockText}>
          {translate(isLoggedIn ? 'page.video.subscribeToWatch' : 'page.video.joinToWatch')}
        </Typography>
        <Typography className={defaultClasses.description}>
          {translate('page.video.videosAvilibility')}
        </Typography>
        <a href="/pricing" className={defaultClasses.link}>
          <CustomButton>
            {translate(isLoggedIn ? 'button.subscribe' : 'button.joinNow')}
          </CustomButton>
        </a>
      </Box>
    </Container>
  );
};

export default JoinNowBlock;
